



































































import {
  Component,
  Prop,
  Vue, Watch,
} from 'vue-property-decorator';

import { Action, Getter, Mutation } from 'vuex-class';
import {OrganisationState, Organisation, Project} from '@/types';
import SearchBar from '@/components/SearchBar.vue';
import OnClickOutside from '../components/OnClickOutside.vue';
import ProjectEdit from '@/components/ProjectEdit.vue';
import ProjectDelete from '@/components/ProjectDelete.vue';
import GenericButton from '@/components/GenericButton.vue';
import EventBus from '@/services/eventbus.service';

@Component({
  components: {
    GenericButton,
    ProjectDelete,
    ProjectEdit,
    SearchBar,
    OnClickOutside,
  },
})

export default class ProjectsSelect extends Vue {
  @Getter private projects: any;
  @Getter private activeOrganisation: any;
  @Getter private activeOrganisationId: any;
  @Getter private activeProject: any;
  @Getter private hasPermission: any;
  @Action private addProjectsAsync: any;
  @Action private changeProjectAsync: any;
  @Action private deleteProjectAsync: any;
  @Mutation private setShowInterface: any;

  private selectedItem: number = 0;
  private project: any = {};
  private editing: boolean = false;
  private showEditProjectDialog: boolean = false;
  private showDeleteProjectDialog: boolean = false;
  private loading: boolean = false;

  // @Watch('activeOrganisationId')
  // private async onOrgChange(value: number, newValue: number) {
  //   if (value !== newValue) {
  //     this.loading = true;
  //     try {
  //       await this.loadProjects();
  //       this.selectedItem = this.items[0].id;
  //     } finally {
  //       this.loading = false;
  //     }
  //   }
  // }

  private async setActiveProject() {
    if (this.activeProject && this.activeProject.length && this.activeProject[0].id) {
      if (this.projects.some((p: any) => p.id === this.activeProject[0].id)) {
        this.selectedItem = this.activeProject[0].id;
      } else {
        await this.changeProjectAsync({projectId: 0, forceRender: true});
      }
    } else {
      this.selectedItem = this.items[0].id;
    }
  }

  private async refreshProjects() {
    this.loading = true;
    try {
      await this.loadProjects();
      await this.setActiveProject();
    } finally {
      this.loading = false;
    }
  }

  private async beforeMount() {
    if (!this.projects) {
      await this.refreshProjects();
    } else {
      await this.setActiveProject();
    }
  }

  private async onChange() {
    await this.changeProjectAsync({projectId: this.selectedItem, forceRender: true});
  }

  private get items() {
    const newValues = this.projects.map((project: any) => ({ name: project.name, id: project.id, user_id: project.user_id }));
    return [{ name: 'All projects', id: 0 }, ...newValues];
  }

  private async loadProjects() {
    await this.addProjectsAsync(
      {
        take: 0,
        skip: 0,
        sort: '',
        desc: '',
        filters: {},
      },
    );
  }

  private editProject(project: any) {
    if (project && project.id > 0) {
      // this should load the updated projects list before user manages to make any significant action in the dialog
      this.refreshProjects();
    }

    this.project = project && project.id > 0 ? project : {name: '', user_id: ''};
    this.editing = !!(project && project.id);
    this.showEditProjectDialog = true;
  }

  private get projectObject(): Project {
    return this.projects.find((p: Project) => p.id === this.project.id);
  }

  private async confirmDelete() {
    Vue.set(this, 'showEditProjectDialog', false);
    this.selectedItem = 0;
    this.loading = true;
    try {
      await this.onChange();
      await this.deleteProjectAsync(this.projectObject);
      await this.refreshProjects();
    } finally {
      this.loading = false;
      EventBus.$emit('ProjectComposer:RefreshLocation');
    }
  }
}
